<template lang="pug">
  b-modal#getTac(
  ref="getTac"
  :title="$t('ui.combine.get_tac')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="account_id"
          type="text"
          v-model="account_id"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.tac_code')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="tac_code"
          type="text"
          v-model="tac_code"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.expiry_date')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="expiry_date"
          type="text"
          v-model="expiry_date"
          :disabled="loading"
        )
      b-form-group(:label="$t('ui.validated_on')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="validated_on"
          type="text"
          v-model="validated_on"
          :disabled="loading"
        )
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: "",
      tac_code: "",
      expiry_date: "",
      validated_on: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      tacList: []
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  methods: {
    getTac: function() {
      let url = config.memberTacGetUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.tacList = response.data.dt;
                this.tac_code = this.tacList.length > 0 ? this.tacList[0].tac : "";
                this.expiry_date = this.tacList.length > 0 ? (this.tacList[0].tac_expiry ? this.$moment(this.tacList[0].tac_expiry).format("YYYY-MM-DD, HH:mm:ss") : "") : "";
                this.validated_on = this.tacList.length > 0 ? (this.tacList[0].verified_date ? this.$moment(this.tacList[0].verified_date).format("YYYY-MM-DD, HH:mm:ss") : "") : "";
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.tac_code = "";
      this.expiry_date = "";
      this.validated_on = "";
      this.getTac();
    }
  }
};
</script>
